import React, {ReactElement, useMemo, useState} from 'react';
// TODO: INSTEAD OF USING MATERIAL UI COMPONENTS DIRECTLY, CREATE GENERIC COMPONENTS IN SYSTEM AND IMPORT IT
import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  makeStyles,
  TextField,
  Typography,
  Tooltip
} from '@material-ui/core';
import {Trans, useTranslation} from 'react-i18next';
import {
  getGuarantor,
  updateGuarantorOptOutElectronicStatement,
  markGuarantorPostedToEmr,
  markGuarantorUpdatedInEmr
} from '@shared/services/PatientsServices';
import {formatApiMessage} from '@shared/utils/formatApiMessage';
import HelperUtils, {
  sanitizeEmrAlphanumericInput
} from '@shared/utils/HelperUtils';
import {getFormattedValue} from '@components/system/CurrencyFormatter/CurrencyFormatter';
import {Permission} from '@shared/services/PermissionService';
import {
  AppPermissions,
  PatientsTabKeys,
  StatementNoticeType
} from '@shared/constants/Mapping';
import {useDispatch, useSelector} from 'react-redux';
import {APP_PRIMARY_COLOR, DEFAULT_WHITE_COLOR} from 'src/style/variable';
import ConfirmationDialog from '@components/system/ConfirmationDialog/ConfirmationDialog';
import MakeSettleStatement from '../../../Invoices/DueInvoices/MakeSettleStatement';
import {useSnackbar} from 'notistack';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import OptOutElectronicStatements from '@components/system/OptOutElectronicStatements/OptOutElectronicStatements';
import CardPayDialog from '@components/system/CardPayDialog/CardPayDialog';
import Loader from '@components/framework/loader/Loader';
import ChangePhoneDialog from '../../../Invoices/DueInvoices/ChangePhoneDialog/ChangePhoneDialog';
import SharePaymentDialog from '../../../Invoices/DueInvoices/SendEmailStatement/SharePaymentDialog';
import GuarantorDrawerComponent from '../../../Invoices/Drawer/GuarantorDrawerComponent';
import ProfileBulkIcon from '@components/system/MyIcons/ProfileBulkIcon';
import SmsIcon from '@components/system/MyIcons/SmsIcon';
import CallIcon from '@components/system/MyIcons/CallIcon';
import NotificationIcon from '@components/system/MyIcons/NotificatonIcon';
import SettingIcon from '@components/system/MyIcons/SettingIcon';
import './GuarantorDetailsCard.scss';
import MessagesIconNew from '@components/system/MyIcons/MessagesIconNew';
import ButtonField from '@components/system/ButtonField/ButtonField';
import TertiaryButton from '@components/system/ButtonField/TertiaryButton';
import PhoneNumberFormatter from '@components/system/PhoneNumberFormatter/PhoneNumberFormatter';
import {_setActiveTab} from '@shared/store/actions/PatientDrawerAction';
import MessagesConversationDialog from '../../../Sms/components/MessagesConversationDialog/MessagesConversationDialog';
import {getLastMessage} from '@shared/services/MessageService';
import LocationIcon from '@components/system/MyIcons/LocationIcon';
import EmrSyncStatusChip from '../../../EmrSync/components/EmrSyncStatusChip';
import {
  canMarkGuarantorPostedInEmr,
  canMarkGuarantorUpdatedInEmr,
  showsGuarantorEmrSyncedChip,
  showsGuarantorPostedEmrDetails,
  showsGuarantorUpdatedEmrDetails,
  toGuarantorEmrRow
} from '../../../EmrSync/utils/guarantorEmrSyncStatus';

const markUpdatedInEmrDialogPrimaryButtonStyle: React.CSSProperties = {
  width: 'auto',
  minWidth: '14rem',
  paddingLeft: '1.5rem',
  paddingRight: '1.5rem'
};

const guarantorDetailsCard = makeStyles(() => ({
  sendMessage: {
    lineHeight: '1rem',
    overflowWrap: 'break-word',
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem'
  },
  LinkStyle: {
    cursor: 'pointer',
    color: APP_PRIMARY_COLOR,
    paddingTop: '0.1rem',
    '&:hover': {
      textDecoration: 'underline'
    },
    fontSize: '1rem',
    display: 'flex'
  },
  linkStyle: {
    cursor: 'pointer',
    color: APP_PRIMARY_COLOR,
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  loaderStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  cardHeader: {
    '& .MuiCardContent-root': {
      padding: '0'
    }
  },

  addNotficationButton: {
    backgroundColor: APP_PRIMARY_COLOR,
    color: DEFAULT_WHITE_COLOR,
    height: '2rem',
    borderColor: APP_PRIMARY_COLOR,
    borderWidth: APP_PRIMARY_COLOR,
    fontSize: '1rem',
    lineHeight: '1rem',
    '&:hover': {
      backgroundColor: APP_PRIMARY_COLOR
    }
  },

  changeButton: {
    background: 'rgba(40, 132, 255, 0.1)',
    borderRadius: '8px',
    padding: '0.3rem',
    paddingInline: '0.75rem',
    color: APP_PRIMARY_COLOR,
    overflowWrap: 'break-word',
    cursor: 'pointer'
  },
  DetailName: {
    // width: '15rem',
    fontSize: '1rem',
    color: '#54585b',
    maxWidth: '20rem',
    overflowWrap: 'break-word'
  },
  emrStatusLink: {
    textAlign: 'right',
    whiteSpace: 'nowrap'
  },
  headerActions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '0.25rem'
  }
}));

interface GuarantorDetailsCardProps {
  resetPagesInGrid?: any;
  guarantorId: number;
  clinicId?: number;
  forceUpdate?: number;
  isGuarantorDrawerLink?: boolean;
  goToMessagesTab?: boolean;
  showEmrSyncActions?: boolean;
  onEmrStatusChange?: () => void;
}
const GuarantorDetailsCard = (
  props: GuarantorDetailsCardProps
): ReactElement => {
  const classes = guarantorDetailsCard();
  const {t} = useTranslation();
  const {
    resetPagesInGrid,
    guarantorId,
    clinicId,
    forceUpdate,
    isGuarantorDrawerLink,
    goToMessagesTab = false,
    showEmrSyncActions = true,
    onEmrStatusChange
  } = props;
  // FIXME: ADD PROPER TYPES
  const userPermissions = useSelector(
    (state: any) => state.auth.userPermissions
  );
  const groupId = useSelector((state: any) => state.auth.groupId);
  const dispatch = useDispatch();

  const [guarantorInfo, setGuarantorInfo]: any = useState([]);
  const {enqueueSnackbar} = useSnackbar();
  const [
    isLoadingGuarantorDetails,
    setIsLoadingGuarantorDetails
  ] = useState<boolean>(true);

  const [patientDetail, setPatientDetail]: any = useState({});
  const acOfClinics: any = useSelector(
    (state: any) => state.clinics.selectedClinicId || []
  );
  const patientShared = useSelector(
    (state: any) => state.clinics.patientShared
  );
  const allClinics: any[] = useSelector(
    (state: any) => state?.clinics?.list || []
  );

  const [
    selectedGuarantorForUpdateNoticeType,
    setSelectedGuarantorForUpdateNoticeType
  ] = useState<any>({});

  const [
    confirmDialogOpenForNoticeType,
    setConfirmDialogOpenForNoticeType
  ] = useState<boolean>(false);

  const [
    optElectronicStatements,
    setOptElectronicStatements
  ] = useState<boolean>(false);

  const [
    optElectronicStatementsForce,
    setOptElectronicStatementsForce
  ] = useState<boolean>(false);

  const [guarantorDrawerOpen, setGuarantorDrawerOpen] = useState<boolean>(
    false
  );

  const [cardPopUpOpen, setCardPopUpOpen] = useState<boolean>(false);

  const [phonePopOver, setPhonePopOver] = useState<boolean>(false);

  const acOfClinicLabels: any = useSelector(
    (state: any) => state.clinics.selectedClinicLabel || []
  );

  const [emailPopOver, setEmailPopOver] = useState<boolean>(false);

  const [showConversation, setShowConversation] = useState<boolean>(false);
  const [showConversationDataObj, setShowConversationDataObj] = useState<any>(
    {}
  );
  const [isPostingGuarantorToEmr, setIsPostingGuarantorToEmr] = useState(false);
  const [
    isMarkingGuarantorUpdatedInEmr,
    setIsMarkingGuarantorUpdatedInEmr
  ] = useState(false);
  const [postGuarantorToEmrDialog, setPostGuarantorToEmrDialog] = useState({
    open: false,
    accountNumber: ''
  });
  const [
    markGuarantorUpdatedInEmrDialogOpen,
    setMarkGuarantorUpdatedInEmrDialogOpen
  ] = useState(false);

  const hasEditPatientPermission = Permission.hasPatientPermissions(
    userPermissions,
    AppPermissions.PATIENT.EDIT,
    groupId
  );

  const guarantorEmrRow = useMemo(() => toGuarantorEmrRow(patientDetail), [
    patientDetail
  ]);

  const showGuarantorEmrActionInHeader =
    showEmrSyncActions &&
    Boolean(guarantorId) &&
    (canMarkGuarantorPostedInEmr(guarantorEmrRow) ||
      canMarkGuarantorUpdatedInEmr(guarantorEmrRow));

  const showGuarantorEmrStatusInDetails =
    showEmrSyncActions &&
    Boolean(guarantorId) &&
    showsGuarantorEmrSyncedChip(guarantorEmrRow);

  const closeGuarantorDrawer = (): void => {
    setGuarantorDrawerOpen(false);
  };
  const resolvedClinicId =
    acOfClinics[0] ??
    clinicId ??
    (patientShared ? allClinics?.[0]?.id : undefined);

  const fetchGuarantorDetails = async () => {
    if (guarantorId && resolvedClinicId) {
      getGuarantor(groupId, guarantorId, resolvedClinicId)
        .then(async res => {
          if (res && res?.data) {
            setGuarantorInfo(res?.data);
            setPatientDetail(res?.data?.guarantor || {});
          }
        })
        .catch(err => {
          enqueueSnackbar(
            (err && err.message) || t('PATIENTS.GET_PATIENT_DETAILS_ERROR'),
            SnackBarConfig('e')
          );
        })
        .finally(() => {
          setIsLoadingGuarantorDetails(false);
        });
      return;
    }
    if (guarantorId) {
      setIsLoadingGuarantorDetails(false);
      enqueueSnackbar(
        t('PATIENTS.SELECT_CLINIC_FOR_FILTER'),
        SnackBarConfig('e')
      );
    }
  };

  React.useEffect(() => {
    fetchGuarantorDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guarantorId, forceUpdate, resolvedClinicId]);

  const openPostGuarantorToEmrDialog = (): void => {
    if (
      !canMarkGuarantorPostedInEmr(guarantorEmrRow) ||
      isPostingGuarantorToEmr ||
      !patientDetail?.id
    ) {
      return;
    }

    setPostGuarantorToEmrDialog({
      open: true,
      accountNumber: patientDetail?.emr_id || ''
    });
  };

  const closePostGuarantorToEmrDialog = (): void => {
    setPostGuarantorToEmrDialog({
      open: false,
      accountNumber: ''
    });
  };

  const handleMarkGuarantorPostedToEmr = async (): Promise<void> => {
    const enteredAccountNumber = postGuarantorToEmrDialog.accountNumber.trim();

    if (
      !canMarkGuarantorPostedInEmr(guarantorEmrRow) ||
      isPostingGuarantorToEmr ||
      !patientDetail?.id
    ) {
      return;
    }

    try {
      setIsPostingGuarantorToEmr(true);
      const response = await markGuarantorPostedToEmr(
        groupId,
        patientDetail.id,
        {
          account_number: enteredAccountNumber || undefined
        }
      );
      if (response) {
        enqueueSnackbar(
          response.message ||
            t('PATIENTS.GUARANTOR_POSTED_TO_EMR_STATUS_SAVED'),
          SnackBarConfig('s')
        );
        closePostGuarantorToEmrDialog();
        await fetchGuarantorDetails();
        onEmrStatusChange?.();
      }
    } catch (error: any) {
      enqueueSnackbar(formatApiMessage(error), SnackBarConfig('e'));
    } finally {
      setIsPostingGuarantorToEmr(false);
    }
  };

  const openMarkGuarantorUpdatedInEmrDialog = (): void => {
    if (
      !canMarkGuarantorUpdatedInEmr(guarantorEmrRow) ||
      isMarkingGuarantorUpdatedInEmr
    ) {
      return;
    }

    setMarkGuarantorUpdatedInEmrDialogOpen(true);
  };

  const closeMarkGuarantorUpdatedInEmrDialog = (): void => {
    setMarkGuarantorUpdatedInEmrDialogOpen(false);
  };

  const handleMarkGuarantorUpdatedInEmr = async (): Promise<void> => {
    if (
      !canMarkGuarantorUpdatedInEmr(guarantorEmrRow) ||
      isMarkingGuarantorUpdatedInEmr
    ) {
      return;
    }

    try {
      setIsMarkingGuarantorUpdatedInEmr(true);
      const response = await markGuarantorUpdatedInEmr(
        groupId,
        patientDetail.id
      );
      if (response) {
        enqueueSnackbar(
          response.message ||
            t('PATIENTS.GUARANTOR_UPDATED_IN_EMR_STATUS_SAVED'),
          SnackBarConfig('s')
        );
        closeMarkGuarantorUpdatedInEmrDialog();
        await fetchGuarantorDetails();
        onEmrStatusChange?.();
      }
    } catch (error: any) {
      enqueueSnackbar(formatApiMessage(error), SnackBarConfig('e'));
    } finally {
      setIsMarkingGuarantorUpdatedInEmr(false);
    }
  };

  const renderGuarantorEmrStatus = (): React.ReactNode => {
    if (!guarantorId) {
      return null;
    }

    if (canMarkGuarantorPostedInEmr(guarantorEmrRow)) {
      if (!hasEditPatientPermission) {
        return t('PATIENTS.EMR_STATUS_GUARANTOR_NOT_POSTED');
      }

      return (
        <Link
          component="button"
          className={`link-style ${classes.emrStatusLink}`}
          variant="body2"
          disabled={isPostingGuarantorToEmr}
          onClick={openPostGuarantorToEmrDialog}>
          {t('PATIENTS.MARK_POSTED_IN_EMR')}
        </Link>
      );
    }

    if (guarantorId && !guarantorEmrRow?.guarantor_posted_to_emr) {
      return t('PATIENTS.EMR_STATUS_GUARANTOR_NOT_POSTED');
    }

    if (canMarkGuarantorUpdatedInEmr(guarantorEmrRow)) {
      if (!hasEditPatientPermission) {
        return t('PATIENTS.EMR_STATUS_GUARANTOR_NOT_UPDATED');
      }

      return (
        <Link
          component="button"
          className={`link-style ${classes.emrStatusLink}`}
          variant="body2"
          disabled={isMarkingGuarantorUpdatedInEmr}
          onClick={openMarkGuarantorUpdatedInEmrDialog}>
          {t('PATIENTS.UPDATE_IN_EMR')}
        </Link>
      );
    }

    if (showsGuarantorEmrSyncedChip(guarantorEmrRow)) {
      return <EmrSyncStatusChip hasIntegration syncStatus="synced" />;
    }

    return null;
  };

  const formatEmrActorName = (name?: string | number | null): string => {
    if (typeof name === 'string') {
      return name.trim();
    }
    return '';
  };

  const renderPostedByName = (): string => {
    const postedBy = formatEmrActorName(patientDetail?.posted_by_name);
    return (
      postedBy ||
      (patientDetail?.posted_to_emr
        ? 'Inbound EMR Sync'
        : t('COMMON.NONE_VALUE'))
    );
  };

  const renderPostedOnDate = (): string => {
    if (!patientDetail?.posted_at) {
      return t('COMMON.NONE_VALUE');
    }
    return HelperUtils.formatDisplayDateTime(patientDetail.posted_at);
  };

  const renderUpdatedInEmrByName = (): string => {
    const updatedBy = formatEmrActorName(patientDetail?.updated_in_emr_by_name);
    return updatedBy || t('COMMON.NONE_VALUE');
  };

  const renderUpdatedInEmrOnDate = (): string => {
    if (!patientDetail?.updated_in_emr_at) {
      return t('COMMON.NONE_VALUE');
    }
    return HelperUtils.formatDisplayDateTime(patientDetail.updated_in_emr_at);
  };

  const renderGuarantorEmrStatusInDetails = (): React.ReactNode => {
    if (showsGuarantorEmrSyncedChip(guarantorEmrRow)) {
      return <EmrSyncStatusChip hasIntegration syncStatus="synced" />;
    }

    return t('PATIENTS.NOT_AVAILABLE');
  };

  const renderDetailRow = (
    label: string,
    value: React.ReactNode,
    options?: {
      icon?: React.ReactNode;
      testId?: string;
    }
  ): ReactElement => (
    <div className="icon-wrapper">
      <div className="icon-child-wrapper">
        <div
          className={[
            'icon-style',
            options?.icon ? '' : 'icon-style--spacer'
          ].join(' ')}>
          {options?.icon}
        </div>
        <div className="detail-row-label">{label}</div>
      </div>
      <Typography className={[classes.DetailName, 'detail-colon'].join(' ')}>
        :
      </Typography>
      <div className="icon-child-wrapper" data-test-id={options?.testId}>
        {value}
      </div>
    </div>
  );

  const renderFullAddress = (detailsObject: any) => {
    if (!detailsObject) {
      return '';
    } else {
      return HelperUtils.formatFullAddress({
        line1: detailsObject.address_line_1,
        line2: detailsObject.address_line_2,
        city: detailsObject.city,
        state: detailsObject.state,
        zip: detailsObject.zip_code
      });
    }
  };

  const renderConfirmationForUpdateStatementType = () => {
    if (
      confirmDialogOpenForNoticeType &&
      selectedGuarantorForUpdateNoticeType.dueNoticeType ===
        StatementNoticeType.STD.key
    ) {
      return (
        <MakeSettleStatement
          title={
            <Trans
              i18nKey={
                selectedGuarantorForUpdateNoticeType.dueNoticeType ===
                StatementNoticeType.STD.key
                  ? 'DUE_INVOICES.SETTLE_STATEMENT_TITLE'
                  : 'DUE_INVOICES.UPDATE_DUE_NOTICE_TYPE_TITLE'
              }
              values={{
                name: selectedGuarantorForUpdateNoticeType.name
              }}
              components={[<strong key={'X'} />]}
            />
          }
          subTitle={
            <Trans
              i18nKey={
                selectedGuarantorForUpdateNoticeType.dueNoticeType ===
                StatementNoticeType.STD.key
                  ? 'DUE_INVOICES.SETTLE_DUE_NOTICE_TYPE_NOTE'
                  : 'DUE_INVOICES.UPDATE_DUE_NOTICE_TYPE_NOTE'
              }
              values={{
                notice_type:
                  selectedGuarantorForUpdateNoticeType.dueNoticeTypeLabel,
                name: selectedGuarantorForUpdateNoticeType.name
              }}
              components={[<strong key={'X'} />]}
            />
          }
          open={confirmDialogOpenForNoticeType}
          onClose={res => {
            setConfirmDialogOpenForNoticeType(false);
            setSelectedGuarantorForUpdateNoticeType({});
            if (res === 'submit') {
              if (typeof resetPagesInGrid === 'function') {
                resetPagesInGrid();
              }
              if (typeof fetchGuarantorDetails == 'function') {
                fetchGuarantorDetails();
              }
            }
          }}
          clinicId={resolvedClinicId}
          groupId={groupId}
          guarantorId={selectedGuarantorForUpdateNoticeType.id}
        />
      );
    }
    return (
      <ConfirmationDialog
        open={confirmDialogOpenForNoticeType}
        onClose={response => {
          setConfirmDialogOpenForNoticeType(false);
          setSelectedGuarantorForUpdateNoticeType({});
        }}
        title={
          <Trans
            i18nKey={
              selectedGuarantorForUpdateNoticeType.dueNoticeType ===
              StatementNoticeType.STD.key
                ? 'DUE_INVOICES.SETTLE_STATEMENT_TITLE'
                : 'DUE_INVOICES.UPDATE_DUE_NOTICE_TYPE_TITLE'
            }
            values={{
              name: selectedGuarantorForUpdateNoticeType.name
            }}
            components={[<strong key={'X'} />]}
          />
        }
        description={
          <Trans
            i18nKey={
              selectedGuarantorForUpdateNoticeType.dueNoticeType ===
              StatementNoticeType.STD.key
                ? 'DUE_INVOICES.SETLLE_DUE_NOTICE_TYPE_NOTE'
                : 'DUE_INVOICES.UPDATE_DUE_NOTICE_TYPE_NOTE'
            }
            values={{
              notice_type:
                selectedGuarantorForUpdateNoticeType.dueNoticeTypeLabel,
              name: selectedGuarantorForUpdateNoticeType.name
            }}
            components={[<strong key={'X'} />]}
          />
        }
      />
    );
  };

  const handleOpenCloseOptOutElectronicStatementDialog = () => {
    setOptElectronicStatements(!optElectronicStatements);
    setOptElectronicStatementsForce(!optElectronicStatements);
  };

  const handleGuarantorOptOutElectronicStatement = async (
    flag: boolean,
    optedOutData: any
  ) => {
    try {
      const notificationObj = optedOutData;

      const updateResponse = await updateGuarantorOptOutElectronicStatement(
        groupId,
        guarantorId,
        resolvedClinicId,
        notificationObj
      );
      if (updateResponse) {
        enqueueSnackbar(
          updateResponse && updateResponse.message,
          SnackBarConfig('s')
        );
        fetchGuarantorDetails();
      }
    } catch (error: any) {
      enqueueSnackbar(error && error.message, SnackBarConfig('e'));
    } finally {
      handleOpenCloseOptOutElectronicStatementDialog();
    }
  };

  const closePayPopOver = () => {
    setCardPopUpOpen(false);
    // props._guarantorPayAmount(0);
  };
  const renderCardPopUp = (): ReactElement => {
    return (
      <CardPayDialog
        guarantorId={patientDetail?.id}
        clinicId={resolvedClinicId}
        clinicGroupId={groupId}
        guarantorName={HelperUtils.commaSeparatedFullName(
          patientDetail?.first_name,
          patientDetail?.last_name,
          patientDetail?.middle_name
        )}
        guarantorDetails={{
          id: patientDetail?.id,
          first_name: patientDetail?.first_name,
          last_name: patientDetail?.last_name,
          middle_name: patientDetail?.middle_name,
          clinic_group_id: patientDetail?.clinic_group_id,
          clinic_id: patientDetail?.clinic_id,
          email: patientDetail?.email,
          address_line_1: patientDetail?.address_line_1,
          zip_code: patientDetail.zip_code
        }}
        open={cardPopUpOpen}
        handleClose={reason => {
          if (
            (reason === 'success' && typeof resetPagesInGrid === 'function') ||
            (reason === 'success' && typeof fetchGuarantorDetails == 'function')
          ) {
            resetPagesInGrid();
            fetchGuarantorDetails();
          }
          closePayPopOver();
        }}
      />
    );
  };
  const closeEmailPopOver = () => {
    setEmailPopOver(false);
  };
  // *** Messages Dialog component start *** //

  // function for opening messages conversation from material-UI dialog
  const onSendMessageClick = async (data: any): Promise<void> => {
    // WHEN CLICKED ON THE SEND MESSAGE BUTTON, MOVE TO MESSAGES TAB IN PATIENT DETAILS DRAWER
    if (goToMessagesTab) {
      dispatch(_setActiveTab(PatientsTabKeys.MESSAGES));
    } else {
      try {
        const lastMessageObj = await getLastMessage(
          groupId,
          resolvedClinicId,
          data.id
        );
        setShowConversationDataObj({
          messageId: lastMessageObj.data?.id,
          clinicId: resolvedClinicId,
          guarantorId: data.id
        });
        setShowConversation(true);
      } catch (err: any) {
        enqueueSnackbar(err && err.message, SnackBarConfig('e'));
        throw err;
      }
    }
  };

  const handleConversationClose = () => {
    setShowConversation(false);
    setShowConversationDataObj({});
  };

  const renderMessagesDialog = () => {
    return (
      <MessagesConversationDialog
        groupId={groupId}
        clinicId={showConversationDataObj?.clinicId}
        messageId={showConversationDataObj?.messageId}
        guarantorId={showConversationDataObj?.guarantorId}
        handleClose={handleConversationClose}
        showConversation={showConversation}
      />
    );
  };

  // *** Messages Dialog End *** //

  const phone1 = patientDetail?.phone || patientDetail?.guarantor_phone;
  const phone2 = patientDetail?.phone_2 || patientDetail?.guarantor_phone_2;
  const phone3 = patientDetail?.phone_3 || patientDetail?.guarantor_phone_3;
  // FIXME: ADD THE FILTER TO ALL PHONE IT SELF, DON'T NEED TO CREATE ANOTHER VARIABLE
  const allPhone = [phone1, phone2, phone3];
  const formattedAllPhone = allPhone.filter(s => s !== undefined);

  const guarantorFullName =
    HelperUtils.commaSeparatedFullName(
      patientDetail.guarantor_first_name || patientDetail.first_name,
      patientDetail.guarantor_last_name || patientDetail.last_name
    ) ?? '';

  return (
    <div>
      <div className="main-class">
        <Typography
          className="card-title"
          data-test-id="pcl-payments-guarantorDetailsTitle">
          {t('PATIENTS.DRAWER.GUARANTOR_DETAILS.TITLE')}
        </Typography>
        {isLoadingGuarantorDetails && (
          <div className={classes.loaderStyle}>{<Loader />}</div>
        )}
        {!isLoadingGuarantorDetails && (
          <>
            <Card className={classes.cardHeader + ' ' + 'card-header'}>
              <CardContent>
                <div className="top-div">
                  <div className="card-name-header">
                    <div className="profile-message-wrapper">
                      <div className="profile-icon">
                        {<ProfileBulkIcon className="user-avatar" />}
                      </div>
                      <div
                        className={`patient-name ${
                          isGuarantorDrawerLink ? `link-style` : ''
                        }`}
                        onClick={() => {
                          if (isGuarantorDrawerLink === true) {
                            setGuarantorDrawerOpen(true);
                          }
                        }}
                        data-test-id="pcl-patientRecall-guarantorName">
                        {guarantorFullName}
                      </div>
                    </div>

                    <div className={classes.headerActions}>
                      {showGuarantorEmrActionInHeader ? (
                        <Tooltip
                          title={
                            canMarkGuarantorPostedInEmr(guarantorEmrRow)
                              ? t('PATIENTS.MARK_POSTED_IN_EMR').toString()
                              : t('PATIENTS.UPDATE_IN_EMR').toString()
                          }
                          placement="top">
                          <span>{renderGuarantorEmrStatus()}</span>
                        </Tooltip>
                      ) : null}
                      {(Permission.hasIncomingSmsPermissions(
                        userPermissions,
                        AppPermissions.INCOMING_SMS.REPLY,
                        groupId
                      ) as any) &&
                        (patientDetail?.notification_phone ||
                          patientDetail?.guarantor_notification_phone) && (
                          <Tooltip
                            title={t('DUE_INVOICES.SEND_MESSAGE').toString()}>
                            <TertiaryButton
                              data-test-id="pcl-payments-sendMessageLinkGuarantorDrawer"
                              startIcon={<MessagesIconNew />}
                              onClick={() => onSendMessageClick(patientDetail)}>
                              {t('DUE_INVOICES.SEND_MESSAGE')}
                            </TertiaryButton>
                          </Tooltip>
                        )}
                    </div>
                  </div>
                  <div className="card-name-child">
                    <div className="card-name-child-wrapper">
                      <div
                        className="card-name-details"
                        data-test-id="pcl-payments-guarantorFirstNameInDrawer">
                        {t('PATIENTS.DRAWER.GUARANTOR_DETAILS.FIRST_NAME')}
                      </div>
                      <div
                        className="card-name-details"
                        data-test-id="pcl-payments-guarantorLastNameInDrawer">
                        {t('PATIENTS.DRAWER.GUARANTOR_DETAILS.LAST_NAME')}
                      </div>
                      <div
                        className="card-name-details"
                        data-test-id="pcl-payments-accountNoInDrawer">
                        {t('PATIENT_DETAILS_CARD.ACCOUNT_NUMBER')}
                      </div>
                    </div>
                    <div className="card-name-child-wrapper-2">
                      <div
                        className="card-name-child-next "
                        data-test-id="pcl-statements-guarantorFirstName">
                        {patientDetail.first_name ?? '-'}
                      </div>
                      <div
                        className="card-name-child-next"
                        data-test-id="pcl-statements-guarantorLastName">
                        {patientDetail.last_name ?? '-'}
                      </div>
                      <div
                        className="card-name-child-next "
                        data-test-id="pcl-statements-guarantorAccountNumber">
                        {`${patientDetail.emr_id ?? '-'}`}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="final-div">
                  <div className="icon-wrapper">
                    <div className="icon-child-wrapper">
                      <div
                        className="icon-style"
                        data-test-id="pcl-payments-guarantorEmailInDrawer">
                        {<SmsIcon />}
                      </div>
                      <div>{t('PATIENT_DETAILS_CARD.EMAIL')}</div>
                    </div>

                    <Typography className={classes.DetailName}>:</Typography>
                    <div
                      className="icon-child-wrapper"
                      data-test-id="pcl-statements-guarantorEmailId">
                      {patientDetail.email || t('PATIENTS.NOT_AVAILABLE')}
                    </div>
                  </div>
                  <div className="icon-wrapper">
                    <div className="icon-child-wrapper">
                      <div className="icon-style">{<CallIcon />}</div>
                      <div>{t('PATIENTS.DRAWER.PHONE')}</div>
                    </div>

                    <Typography className={classes.DetailName}>:</Typography>

                    <div
                      className="icon-child-wrapper all-phone-wrapper"
                      data-test-id="pcl-statements-guarantorPhoneNumber">
                      {formattedAllPhone.length !== 0 ? (
                        <>
                          {formattedAllPhone.map((formattedPhone, idx) => (
                            <div
                              key={idx}
                              className="phone-number-wrapper"
                              data-test-id="pcl-payments-guarantorPhone1InDrawer">
                              <PhoneNumberFormatter value={formattedPhone} />
                              {/* {idx !== formattedAllPhone.length - 1 && `,`} */}
                            </div>
                          ))}
                        </>
                      ) : (
                        t('PATIENTS.NOT_AVAILABLE')
                      )}
                    </div>
                  </div>
                  <div className="icon-wrapper">
                    <div className="icon-child-wrapper">
                      <div className="icon-style">{<NotificationIcon />}</div>
                      <div>
                        {t(
                          'PATIENTS.DRAWER.GUARANTOR_DETAILS.NOTIFICATION_PHONE'
                        )}
                      </div>
                    </div>
                    <Typography className={classes.DetailName}>:</Typography>
                    <div
                      className="icon-child-wrapper"
                      data-test-id="pcl-payments-guarantorNotificationPhoneInDrawer">
                      {patientDetail?.notification_phone ||
                      patientDetail?.guarantor_notification_phone ? (
                        <PhoneNumberFormatter
                          value={
                            patientDetail?.notification_phone ??
                            patientDetail?.guarantor_notification_phone
                          }
                        />
                      ) : (
                        t('PATIENTS.NOT_AVAILABLE')
                      )}

                      {(Permission.hasPatientPermissions(
                        userPermissions,
                        AppPermissions.PATIENT.EDIT_NOTIFICATION_PHONE,
                        groupId
                      ) as any) && (
                        <div
                          className="edit-button"
                          data-test-id="pcl-payments-editLinkGuarantorDrawer">
                          {
                            <Tooltip
                              title={
                                patientDetail?.notification_phone ||
                                patientDetail?.guarantor_notification_phone
                                  ? t(
                                      'DUE_INVOICES.EDIT_NOTIFICATION_PHONE'
                                    ).toString()
                                  : t(
                                      'DUE_INVOICES.ADD_NOTIFICATION_PHONE'
                                    ).toString()
                              }>
                              <div>
                                {patientDetail?.notification_phone ||
                                patientDetail?.guarantor_notification_phone ? (
                                  <TertiaryButton
                                    onClick={(e: any) => {
                                      setPhonePopOver(true);
                                    }}
                                    size="small">
                                    {t('DUE_INVOICES.EDIT')}
                                  </TertiaryButton>
                                ) : (
                                  <ButtonField
                                    onClick={(e: any) => {
                                      setPhonePopOver(true);
                                    }}
                                    buttonText={t('COMMON.ADD')}
                                    className={[
                                      classes.addNotficationButton
                                    ].join(' ')}>
                                    {t('DUE_INVOICES.ADD')}
                                  </ButtonField>
                                )}
                              </div>
                            </Tooltip>
                          }
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="icon-wrapper">
                    <div className="icon-child-wrapper">
                      <div className="icon-style">{<LocationIcon />}</div>
                      <div>{t('PATIENTS.DRAWER.ADDRESS')}</div>
                    </div>
                    <Typography className={classes.DetailName}>:</Typography>
                    <div
                      className="icon-child-wrapper"
                      data-test-id="pcl-patientRecall-patientAddress">
                      {renderFullAddress(patientDetail) !== ''
                        ? renderFullAddress(patientDetail)
                        : t('PATIENTS.NOT_AVAILABLE')}
                    </div>
                  </div>
                  {showEmrSyncActions ? (
                    <>
                      {showGuarantorEmrStatusInDetails
                        ? renderDetailRow(
                            t('PATIENTS.EMR_POSTED_STATUS_LABEL'),
                            renderGuarantorEmrStatusInDetails(),
                            {testId: 'pcl-patientRecall-guarantorEmrStatus'}
                          )
                        : null}
                      {showsGuarantorUpdatedEmrDetails(guarantorEmrRow) ? (
                        <>
                          {renderDetailRow(
                            t('PATIENTS.EMR_UPDATED_BY'),
                            renderUpdatedInEmrByName(),
                            {testId: 'pcl-patientRecall-guarantorEmrUpdatedBy'}
                          )}
                          {renderDetailRow(
                            t('PATIENTS.EMR_UPDATED_ON'),
                            renderUpdatedInEmrOnDate(),
                            {testId: 'pcl-patientRecall-guarantorEmrUpdatedOn'}
                          )}
                        </>
                      ) : null}
                      {showsGuarantorPostedEmrDetails(guarantorEmrRow) ? (
                        <>
                          {renderDetailRow(
                            t('PATIENTS.EMR_POSTED_BY'),
                            renderPostedByName(),
                            {testId: 'pcl-patientRecall-guarantorEmrPostedBy'}
                          )}
                          {renderDetailRow(
                            t('PATIENTS.EMR_POSTED_ON'),
                            renderPostedOnDate(),
                            {testId: 'pcl-patientRecall-guarantorEmrPostedOn'}
                          )}
                        </>
                      ) : null}
                    </>
                  ) : null}
                  {Permission.hasNotificationHistoryPermissions(
                    userPermissions,
                    AppPermissions.NOTIFICATION_HISTORY.LIST,
                    groupId
                  ) &&
                    Permission.hasStatementPermissions(
                      userPermissions,
                      AppPermissions.STATEMENT.LIST,
                      groupId
                    ) && (
                      <div className="icon-wrapper">
                        <div className="icon-child-wrapper">
                          <div className="icon-style">{<SettingIcon />}</div>
                          <div>
                            {t('PATIENT_DETAILS_CARD.NOTIFICATION_PREFERENCE')}
                          </div>
                        </div>
                        <Typography className={classes.DetailName}>
                          :
                        </Typography>
                        <div
                          className="edit-button"
                          data-test-id="pcl-payments-guarantorDetailsChange">
                          <Tooltip
                            title={t('PATIENT_DETAILS_CARD.CHANGE').toString()}>
                            <TertiaryButton
                              className={classes.changeButton}
                              onClick={() => {
                                handleOpenCloseOptOutElectronicStatementDialog();
                              }}
                              size="small">
                              {t('PATIENT_DETAILS_CARD.CHANGE')}
                            </TertiaryButton>
                          </Tooltip>
                        </div>
                      </div>
                    )}
                  {cardPopUpOpen && renderCardPopUp()}
                </div>
              </CardContent>
            </Card>
            {confirmDialogOpenForNoticeType &&
              renderConfirmationForUpdateStatementType()}
            {cardPopUpOpen && renderCardPopUp()}
            {optElectronicStatements && (
              <OptOutElectronicStatements
                open={optElectronicStatements}
                onClose={() => {
                  handleOpenCloseOptOutElectronicStatementDialog();
                }}
                onConfirm={(response: boolean, optedOutData: any) => {
                  handleGuarantorOptOutElectronicStatement(
                    response,
                    optedOutData
                  );
                }}
                forceUpdate={optElectronicStatementsForce}
                clinicId={resolvedClinicId}
                groupId={groupId}
                guarantorId={guarantorId}
              />
            )}
            {phonePopOver && (
              <ChangePhoneDialog
                title={
                  <Trans
                    i18nKey={'DUE_INVOICES.NOTIFICATION_DIALOG.HEADING'}
                    values={{
                      // guarantorName: selectedGuarantor.name
                      guarantorName: HelperUtils.commaSeparatedFullName(
                        patientDetail.guarantor_first_name ||
                          patientDetail.first_name,
                        patientDetail.guarantor_last_name ||
                          patientDetail.last_name
                      )
                    }}
                    components={[<strong key={'X'} />]}
                  />
                }
                subtitle={t('DUE_INVOICES.NOTIFICATION_DIALOG.TITLE')}
                open={phonePopOver}
                onClose={(): void => {
                  setPhonePopOver(false);
                  fetchGuarantorDetails();
                }}
                groupId={groupId}
                selectedGuarantor={{
                  ...patientDetail,
                  balance_amount:
                    (patientDetail?.guarantor_due &&
                      patientDetail?.guarantor_due?.current_due_amount) ||
                    0
                }}
                clinicId={resolvedClinicId}
                showSendRemainder={
                  Permission.hasStatementPermissions(
                    userPermissions,
                    AppPermissions.STATEMENT?.SEND_REMINDER,
                    groupId
                  ) as any
                }
              />
            )}
            {emailPopOver && (
              <SharePaymentDialog
                open={emailPopOver}
                onClose={closeEmailPopOver}
                title={
                  <Trans
                    i18nKey={'DUE_INVOICES.EMAIL_DIALOG.SHARE_PAYMENT_HEADING'}
                    values={{
                      guarantorName: HelperUtils.commaSeparatedFullName(
                        patientDetail.guarantor_first_name ||
                          patientDetail.first_name,
                        patientDetail.guarantor_last_name ||
                          patientDetail.last_name
                      )
                    }}
                    components={[<strong key={'X'} />]}
                  />
                }
                subtitle={
                  <Trans
                    i18nKey={'DUE_INVOICES.EMAIL_DIALOG.SHARE_PAYMENT_SUBTITLE'}
                    values={{
                      amount: getFormattedValue(
                        patientDetail.guarantor_due?.current_due_amount,
                        true
                      ),
                      clinicName: acOfClinicLabels[0],
                      guarantorName: HelperUtils.commaSeparatedFullName(
                        patientDetail.guarantor_first_name ||
                          patientDetail.first_name,
                        patientDetail.guarantor_last_name ||
                          patientDetail.last_name
                      )
                    }}
                    components={[<strong key={'X'} />]}
                  />
                }
                groupId={groupId}
                selectedGuarantor={{
                  ...patientDetail,
                  balance_amount:
                    patientDetail.guarantor_due?.current_due_amount
                }}
                clinicId={resolvedClinicId}
              />
            )}
            {showConversation && renderMessagesDialog()}
            <Dialog
              open={postGuarantorToEmrDialog.open}
              onClose={closePostGuarantorToEmrDialog}
              maxWidth="sm"
              fullWidth>
              <DialogTitle>
                {t('PATIENTS.POST_GUARANTOR_TO_EMR_DIALOG_TITLE')}
              </DialogTitle>
              <DialogContent>
                <Typography variant="body2" gutterBottom>
                  {t('PATIENTS.POST_GUARANTOR_TO_EMR_DIALOG_SUBTITLE')}
                </Typography>
                <TextField
                  autoFocus
                  fullWidth
                  margin="dense"
                  label={t('PATIENTS.GUARANTOR_ACCOUNT_NUMBER')}
                  value={postGuarantorToEmrDialog.accountNumber}
                  onChange={e =>
                    setPostGuarantorToEmrDialog(d => ({
                      ...d,
                      accountNumber: sanitizeEmrAlphanumericInput(
                        e.target.value
                      )
                    }))
                  }
                  onKeyDown={e => {
                    if (e.key === 'Enter' && !isPostingGuarantorToEmr) {
                      handleMarkGuarantorPostedToEmr();
                    }
                  }}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={closePostGuarantorToEmrDialog}
                  disabled={isPostingGuarantorToEmr}>
                  {t('COMMON.CANCEL')}
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleMarkGuarantorPostedToEmr}
                  disabled={isPostingGuarantorToEmr}>
                  {t('COMMON.SAVE')}
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog
              open={markGuarantorUpdatedInEmrDialogOpen}
              onClose={closeMarkGuarantorUpdatedInEmrDialog}
              maxWidth="sm"
              fullWidth>
              <DialogTitle>
                {t('PATIENTS.MARK_GUARANTOR_UPDATED_IN_EMR_DIALOG_TITLE')}
              </DialogTitle>
              <DialogContent>
                <Typography variant="body2" gutterBottom>
                  {t('PATIENTS.MARK_GUARANTOR_UPDATED_IN_EMR_DIALOG_SUBTITLE')}
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={closeMarkGuarantorUpdatedInEmrDialog}
                  disabled={isMarkingGuarantorUpdatedInEmr}>
                  {t('COMMON.CANCEL')}
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  style={markUpdatedInEmrDialogPrimaryButtonStyle}
                  onClick={handleMarkGuarantorUpdatedInEmr}
                  disabled={isMarkingGuarantorUpdatedInEmr}>
                  {t('PATIENTS.UPDATE_IN_EMR')}
                </Button>
              </DialogActions>
            </Dialog>
            <GuarantorDrawerComponent
              open={guarantorDrawerOpen}
              closeDrawer={closeGuarantorDrawer}
              guarantorId={guarantorId}
              patientDrawerLinkBoolean={true}
              resetPagesInGrid={resetPagesInGrid}
              guarantorName={HelperUtils.commaSeparatedFullName(
                guarantorInfo?.guarantor?.first_name,
                guarantorInfo?.guarantor?.last_name,
                guarantorInfo?.guarantor?.middle_name
              )}
              clinicId={resolvedClinicId}
              showEmrSyncActions={showEmrSyncActions}
            />
          </>
        )}
      </div>
    </div>
  );
};
export default GuarantorDetailsCard;
